// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-progress {
    background-color: #448aea;
    height: 100vh;
    overflow: hidden;
    position: relative;
    width: 403px;
}

.signup-progress .group {
    height: auto;
    left: 58px;
    position: absolute;
    top: 232px;
    width: 80%;
}

.signup-progress .item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
    padding-left: 30px; /* Increase padding to create more space for the circles */
}

.signup-progress .ellipse {
    background-color: #ffffff;
    border-radius: 3.5px;
    height: 7px;
    width: 7px;

    position: absolute;
    left: 10px; /* Adjust left position */
    top: 50%;
    transform: translateY(-50%);
}

.signup-progress .ellipse.active {
    opacity: 1;
    height: 11px;
    width: 11px;
    border-radius: 5.5px;
    left: 8px; /* Adjust left position for active state */
}

.signup-progress .text {
    color: #ffffff;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 24px;
    white-space: nowrap;
    opacity: 0.5;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-left: 0; /* Remove padding */
}

.signup-progress .text.active {
    opacity: 1;
    font-weight: 600;
}

.signup-progress .frame-wrapper {
    margin-left: auto;
    margin-right: 4px;
}

.signup-progress .div-wrapper {
    background-color: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 100px;
    padding: 2px 6px;
}

.signup-progress .text-2 {
    color: #000000;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 16px;
    white-space: nowrap;
}

.signup-progress .rectangle {
    background-color: #ffffff;
    height: 85px;
    width: 1px;
    position: absolute;
    left: 13px; /* Adjust left position to align with circles */
    top: 15px;
}

.signup-progress .div {
    align-items: center;
    display: inline-flex;
    gap: 16px;
    left: 0;
    position: absolute;
    top: 0;
}

.signup-progress .ellipse-2 {
    background-color: #ffffff;
    border-radius: 5.5px;
    height: 11px;
    position: relative;
    width: 11px;
}

.signup-progress .frame-2 {
    align-items: center;
    display: inline-flex;
    flex: 0 0 auto;
    gap: 8px;
    position: relative;
}

.signup-progress .text-wrapper {
    color: #ffffff;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: -1px;
    position: relative;
    white-space: nowrap;
    width: fit-content;
}

.signup-progress .frame-wrapper {
    height: 24px;
    position: relative;
    width: 79px;
    margin-left: auto;
}

.signup-progress .div-wrapper {
    align-items: flex-start;
    background-color: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 100px;
    display: inline-flex;
    gap: 10px;
    padding: 4px 8px;
    position: relative;
}

.signup-progress .text-2 {
    color: #000000;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 16px;
    margin-top: -1px;
    position: relative;
    white-space: nowrap;
    width: fit-content;
}

.signup-progress .frame-3 {
    align-items: center;
    display: inline-flex;
    gap: 18px;
    left: 2px;
    position: absolute;
    top: 120px;
}

.signup-progress .title {
    color: #ffffff;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
    height: 24px;
    left: 27px;
    letter-spacing: 0;
    line-height: 24px;
    position: absolute;
    bottom: 20px;
    white-space: nowrap;
}

.signup-progress .span {
    color: #ffffff;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 24px;
}

.signup-progress .text-wrapper-2 {
    text-decoration: underline;
}

.signup-progress .quick-easy-setup {
    color: #ffffff;
    font-family: "Fira Sans", sans-serif;
    font-size: 24px;
    font-weight: 700;
    height: 32px;
    left: 27px;
    letter-spacing: 0;
    line-height: 32px;
    position: absolute;
    top: 128px;
    width: 327px;
}`, "",{"version":3,"sources":["webpack://./src/components/SignupProgress/style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB,EAAE,0DAA0D;AAClF;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,UAAU;;IAEV,kBAAkB;IAClB,UAAU,EAAE,yBAAyB;IACrC,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,SAAS,EAAE,0CAA0C;AACzD;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe,EAAE,mBAAmB;AACxC;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU,EAAE,+CAA+C;IAC3D,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB","sourcesContent":[".signup-progress {\n    background-color: #448aea;\n    height: 100vh;\n    overflow: hidden;\n    position: relative;\n    width: 403px;\n}\n\n.signup-progress .group {\n    height: auto;\n    left: 58px;\n    position: absolute;\n    top: 232px;\n    width: 80%;\n}\n\n.signup-progress .item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    position: relative;\n    padding-left: 30px; /* Increase padding to create more space for the circles */\n}\n\n.signup-progress .ellipse {\n    background-color: #ffffff;\n    border-radius: 3.5px;\n    height: 7px;\n    width: 7px;\n\n    position: absolute;\n    left: 10px; /* Adjust left position */\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.signup-progress .ellipse.active {\n    opacity: 1;\n    height: 11px;\n    width: 11px;\n    border-radius: 5.5px;\n    left: 8px; /* Adjust left position for active state */\n}\n\n.signup-progress .text {\n    color: #ffffff;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    letter-spacing: 0;\n    line-height: 24px;\n    white-space: nowrap;\n    opacity: 0.5;\n    flex-grow: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding-left: 0; /* Remove padding */\n}\n\n.signup-progress .text.active {\n    opacity: 1;\n    font-weight: 600;\n}\n\n.signup-progress .frame-wrapper {\n    margin-left: auto;\n    margin-right: 4px;\n}\n\n.signup-progress .div-wrapper {\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    border-radius: 100px;\n    padding: 2px 6px;\n}\n\n.signup-progress .text-2 {\n    color: #000000;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 16px;\n    white-space: nowrap;\n}\n\n.signup-progress .rectangle {\n    background-color: #ffffff;\n    height: 85px;\n    width: 1px;\n    position: absolute;\n    left: 13px; /* Adjust left position to align with circles */\n    top: 15px;\n}\n\n.signup-progress .div {\n    align-items: center;\n    display: inline-flex;\n    gap: 16px;\n    left: 0;\n    position: absolute;\n    top: 0;\n}\n\n.signup-progress .ellipse-2 {\n    background-color: #ffffff;\n    border-radius: 5.5px;\n    height: 11px;\n    position: relative;\n    width: 11px;\n}\n\n.signup-progress .frame-2 {\n    align-items: center;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 8px;\n    position: relative;\n}\n\n.signup-progress .text-wrapper {\n    color: #ffffff;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 24px;\n    margin-top: -1px;\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.signup-progress .frame-wrapper {\n    height: 24px;\n    position: relative;\n    width: 79px;\n    margin-left: auto;\n}\n\n.signup-progress .div-wrapper {\n    align-items: flex-start;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    border-radius: 100px;\n    display: inline-flex;\n    gap: 10px;\n    padding: 4px 8px;\n    position: relative;\n}\n\n.signup-progress .text-2 {\n    color: #000000;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0;\n    line-height: 16px;\n    margin-top: -1px;\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.signup-progress .frame-3 {\n    align-items: center;\n    display: inline-flex;\n    gap: 18px;\n    left: 2px;\n    position: absolute;\n    top: 120px;\n}\n\n.signup-progress .title {\n    color: #ffffff;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    height: 24px;\n    left: 27px;\n    letter-spacing: 0;\n    line-height: 24px;\n    position: absolute;\n    bottom: 20px;\n    white-space: nowrap;\n}\n\n.signup-progress .span {\n    color: #ffffff;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0;\n    line-height: 24px;\n}\n\n.signup-progress .text-wrapper-2 {\n    text-decoration: underline;\n}\n\n.signup-progress .quick-easy-setup {\n    color: #ffffff;\n    font-family: \"Fira Sans\", sans-serif;\n    font-size: 24px;\n    font-weight: 700;\n    height: 32px;\n    left: 27px;\n    letter-spacing: 0;\n    line-height: 32px;\n    position: absolute;\n    top: 128px;\n    width: 327px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
